module.exports = __webpack_public_path__ + "static/media/ContosoLogo.a71e6d96.png";